import React, { useRef } from "react";
import { useState, useEffect } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import "./cadastroUnidades.css";
import Header from "../../components/header/header";
import CustomModal from "../../components/modal/Modal";
import InputMask from "react-input-mask";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faWindowClose } from "@fortawesome/free-solid-svg-icons";
import {
  getUniCadastros,
  getUnidadesById,
  getUniUpdate,
} from "../../services/api_cadastros_unidades";
import { getEmpresas } from "../../services/api_empresas";
import Swal from "sweetalert2";
import Spinner from "react-bootstrap/Spinner";
import estados from "../../hooks/estados.json";
import api from "../../services/api_refresh_token";

const UnidadesRegister = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.state?.id;
  const [nome, setNome] = useState("");
  const [cnpj, setCnpj] = useState("");
  const [inscricao_estadual, setInscEstadual] = useState("");
  const [cep, setCep] = useState("");
  const [endereco, setEndereco] = useState("");
  const [num_endereco, setNumEndereco] = useState("");
  const [bairro, setBairro] = useState("");
  const [cidade, setCidade] = useState("");
  const [uf, setUf] = useState("MG");
  const [id_empresa, setIdEmpresa] = useState("");
  const [nomeMatriz, setNomeMatriz] = useState("");
  const [empresas, setEmpresas] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [isSaving, setSaving] = useState(false)

  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({});

  const inputRefs = {
    Endereco: useRef(null),
    Bairro: useRef(null),
    Cidade: useRef(null),
    Uf: useRef(null),
    NomeMatriz: useRef(null),
    Nome: useRef(null)
  };

  useEffect(() => {
    const fetchUnidade = async () => {
      try {
        const response = await getUnidadesById(id);
        const unidade = response.data.unidade; // Corrigido para acessar response.data.unidade
        if (unidade) {
          setNome(unidade.nome || "");
          setCnpj(unidade.cnpj || "");
          setInscEstadual(unidade.inscricao_estadual || "");
          setCep(unidade.cep || "");
          setEndereco(unidade.endereco || "");
          setNumEndereco(unidade.num_endereco || "");
          setBairro(unidade.bairro || "");
          setCidade(unidade.cidade || "");
          setUf(unidade.estado || ""); // Corrigido para acessar unidade.estado
          setIdEmpresa(unidade.id_empresa || "");
          setNomeMatriz(unidade.empresa.nome || "");
          setLoading(false);
        } else {
          console.error(
            "Dados da unidade não encontrados na resposta: ",
            response
          );
        }
      } catch (error) {
        console.error("Erro ao obter dados da unidade:", error);
      }
    };

    if (id) {
      fetchUnidade();
    }
  }, [id]);

  useEffect(() => {
    const fetchEmpresas = async () => {
      try {
        const response = await getEmpresas();
        //console.log(response.data);

        if (response) {
          const empresasAtivas = response.data.empresas.filter(
            (empresa) => empresa.deleted_at == null
          );
          setEmpresas(empresasAtivas);
          setLoading(false);
        } else {
          console.error("A resposta da API não é uma array:");
        }
        ////console.log(responselog(response.data);
      } catch (error) {
        console.error("Erro ao obter empresas:", error);
      } finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };
    if (!id) {
      fetchEmpresas();
    }
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenModal = (title, body) => {
    setModalContent({ title, body });
    setShowModal(true);
  };

  const validarInputs = () => {
    if (!nome || !cnpj || !id_empresa) {
      Swal.fire({
        icon: "warning",
        title: "Oops!",
        text: "O preenchimento dos campos Nome, CNPJ e Empresa Matriz é obrigatório.",
      });

      return false;
    }

    const filteredCNPJ = cnpj.replace(/\D/g, "");
    if (filteredCNPJ.length < 14) {
      Swal.fire({
        icon: "warning",
        title: "CNPJ inválido",
        text: "O CNPJ deve ter 14 dígitos.",
      });

      return false;
    }

    if (cep) {
      const filteredCep = cep.replace(/\D/g, "");
      if (filteredCep.length < 8) {
        Swal.fire({
          icon: "warning",
          title: "CEP inválido",
          text: "O CEP deve ter 8 dígitos.",
        });

        return false;
      }
    }
    return true;
  };

  const addUniCadastro = async (body) => {
    try {
      const response = await getUniCadastros(body);

      if (response && response.status === 200) {
        regret();
      } else {
        console.error("Erro ao cadastrar unidade:", response);
      }
    } catch (error) {
      console.error("Erro ao cadastrar unidade:", error);
    } finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };

  const newUniUpdate = async (body) => {
    try {
      delete body.cnpj;
      delete body.id_empresa;
      const response = await getUniUpdate(id, body);

      if (response && response.status === 200) {
        regret();
      } else {
        console.error("Erro ao cadastrar unidade:", response);
      }
    } catch (error) {
      if (error.response && error.response.status === 422) {
        handleOpenModal(
          "Erro de validação",
          "Houve um erro na validação dos dados."
        );
      } else if (error.response && error.response.status === 500) {
        handleOpenModal(
          "Erro interno do servidor",
          "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde."
        );
      } else {
        console.error("Erro ao atualizar a empresa:", error);
        handleOpenModal(
          "Erro ao atualizar a empresa",
          "Por favor, tente novamente mais tarde."
        ); // Exibir mensagem genérica de erro
      }
    }finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };

  const handleSalvar = () => {
    if (validarInputs()) {
      setSaving(true)
      let body = {
        nome,
        cnpj,
        inscricao_estadual,
        cep,
        endereco,
        num_endereco,
        bairro,
        cidade,
        estado: uf,
        id_empresa,
        matriz_filial: 0,
      };

      if (id) {
        newUniUpdate(body);
      } else {
        addUniCadastro(body);
      }
    }
  };

  const handleNome = (e) => {
    const value = e.target.value;
    if (value.length <= 50) {
      setNome(value);
    } else {
      handleOpenModal(
        "Número de caracteres excedidos",
        "O campo Nome não pode ultrapassar 50 caracteres"
      );
    }
  };

  const handleBairro = (e) => {
    const value = e.target.value;
    if (value.length <= 50) {
      setBairro(value);
    } else {
      handleOpenModal(
        "Número de caracteres excedidos",
        "O campo Bairro não pode ultrapassar 50 caracteres"
      );
    }
  };

  const handleCidade = (e) => {
    const value = e.target.value;
    if (value.length <= 50) {
      setCidade(value);
    } else {
      handleOpenModal(
        "Número de caracteres excedidos",
        "O campo Cidade não pode ultrapassar 50 caracteres"
      );
    }
  };

  const handleEndereco = (e) => {
    const value = e.target.value;
    if (value.length <= 50) {
      setEndereco(value);
    } else {
      handleOpenModal(
        "Número de caracteres excedidos",
        "O campo Endereço não pode ultrapassar 50 caracteres"
      );
    }
  };

  const handleNumero = (e) => {
    const value = e.target.value;
    if (value.length <= 5) {
      setNumEndereco(value);
    } else {
      handleOpenModal(
        "Número de caracteres excedidos",
        "O campo Número não pode ultrapassar 5 caracteres"
      );
    }
  };

  const handleInscricaoEstadual = (e) => {
    const value = e.target.value;
    if (value.length <= 9) {
      setInscEstadual(value);
    } else {
      handleOpenModal(
        "Número de caracteres excedidos",
        "O campo Inscrição Estadual não pode ultrapassar 9 caracteres"
      );
    }
  };

  const handleCep = async (e) => {
    const cep = e.replace(/\D/g, "");
    if (cep.length === 8) {
      try {
        const dadosCep = await api.get(`https://viacep.com.br/ws/${cep}/json/`);
        if (dadosCep.data.erro) {
          Swal.fire({
            icon: "warning",
            title: "CEP inválido",
            text: "Digite um CEP válido.",
          });
          setEndereco("");
          setBairro("");
          setCidade("");
          setUf("MG");
        } else {
          console.log(dadosCep.data);
          setEndereco(dadosCep.data.logradouro);
          setBairro(dadosCep.data.bairro);
          setCidade(dadosCep.data.localidade);
          setUf(dadosCep.data.uf);
        }
      } catch (error) {
        Swal.fire({
          icon: "warning",
          title: "CEP inválido",
          text: "Digite um CEP válido.",
        });
      }
    }
  };

  const handleKeyDown = (e, nextFieldRef) => {
    if (e.key === 'Enter' && nextFieldRef.current) {
      e.preventDefault();
      const elementToFocus = nextFieldRef.current.inputRef || nextFieldRef.current;
  
      if (typeof elementToFocus.focus === 'function') {
        elementToFocus.focus();
      } else {
        console.warn('O elemento de input não tem o método focus.');
      }
    }
  };
  

  const regret = () => {
    window.history.back();
  };

  return (
    <>
      <Header title="Cadastros / Cadastro de unidades" />
      <div className="content-wrapper pl-5 pr-5 pt-2">
        {isLoading ? (
          <div className="center-btn">
            <h5 className="mb-5">Carregando dados</h5>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <Form className="mt-4">
            <Row>
              <Col md={6} className="mb-3">
                <Form.Group controlId="formNome">
                  <Form.Label>Nome</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Digite o nome"
                    onChange={handleNome}
                    value={nome}
                    ref={inputRefs.Nome}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.Endereco)}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group controlId="formCnpj">
                  <Form.Label>CNPJ</Form.Label>
                  <Form.Control
                    type="text"
                    as={InputMask}
                    placeholder="Digite o CNPJ"
                    mask="99.999.999/9999-99"
                    value={cnpj}
                    onChange={(e) => setCnpj(e.target.value)}
                    disabled={!!id}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6} className="mb-3">
                <Form.Group controlId="formInscEstadual">
                  <Form.Label>Inscrição Estadual</Form.Label>
                  <Form.Control
                    type="text"
                    as={InputMask}
                    mask="999999999"
                    placeholder="Digite a inscrição estadual"
                    value={inscricao_estadual}
                    onChange={handleInscricaoEstadual}
                    // disabled={!!id}
                  />
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group controlId="formCep">
                  <Form.Label>CEP</Form.Label>
                  <Form.Control
                    type="text"
                    as={InputMask}
                    mask="99999-999"
                    placeholder="Digite o CEP"
                    value={cep}
                    onChange={(e) => setCep(e.target.value)}
                    onBlur={(e) => handleCep(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={9} className="mb-3">
                <Form.Group controlId="formEndereco">
                  <Form.Label>Endereço</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Digite o endereço"
                    value={endereco}
                    onChange={handleEndereco}
                    ref={inputRefs.Endereco}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.Bairro)}
                  />
                </Form.Group>
              </Col>
              <Col md={3} className="mb-3">
                <Form.Group controlId="formNumero">
                  <Form.Label>Número</Form.Label>
                  <Form.Control
                    type="text"
                    as={InputMask}
                    mask="99999"
                    placeholder="Digite o número"
                    value={num_endereco}
                    onChange={handleNumero}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={5} className="mb-3">
                <Form.Group controlId="formBairro">
                  <Form.Label>Bairro</Form.Label>
                  <Form.Control
                    type="text"
                    value={bairro}
                    placeholder="Digite o bairro"
                    onChange={handleBairro}
                    ref={inputRefs.Bairro}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.Cidade)}
                  />
                </Form.Group>
              </Col>
              <Col md={5} className="mb-3">
                <Form.Group controlId="formCidade">
                  <Form.Label>Cidade</Form.Label>
                  <Form.Control
                    type="text"
                    value={cidade}
                    placeholder="Digite a cidade"
                    onChange={handleCidade}
                    ref={inputRefs.Cidade}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.Uf)}
                  />
                </Form.Group>
              </Col>
              <Col md={2} className="mb-3">
                <Form.Group controlId="formUF">
                  <Form.Label>U.F.</Form.Label>
                  <Form.Control
                    as="select"
                    value={uf}
                    onChange={(e) => setUf(e.target.value)}
                    ref={inputRefs.Uf}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.NomeMatriz)}
                  >
                    {estados.UF.map((estado) => (
                      <option value={estado.sigla}>{estado.sigla}</option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formEmpresa">
                  <Form.Label>Empresa Matriz</Form.Label>
                  <Form.Control
                    as="select"
                    value={id_empresa}
                    onChange={(e) => setIdEmpresa(e.target.value)}
                    ref={inputRefs.NomeMatriz}
                    disabled={!!id}
                  >
                    {!id ? (
                      <>
                        <option value="">Selecione</option>
                        {empresas.map((empresa) => (
                          <option key={empresa.id} value={empresa.id}>
                            {empresa.nome}
                          </option>
                        ))}
                      </>
                    ) : (
                      <option>{nomeMatriz}</option>
                    )}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <div className="center-two-btn d-flex justify-content-center ">
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={handleSalvar}
                disabled = {isSaving}
              >
                {isSaving ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  <FontAwesomeIcon icon={faSave} />
                )}
              </Button>
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={regret}
              >
                <FontAwesomeIcon icon={faWindowClose} />
              </Button>
            </div>
          </Form>
        )}
      </div>

      <CustomModal
        show={showModal}
        handleClose={handleCloseModal}
        title={modalContent.title}
        body={modalContent.body}
      />
    </>
  );
};

export default UnidadesRegister;
